import {AbstractControl, ValidationErrors} from '@angular/forms';

export const NoWhitespaceValidator = (control: AbstractControl): ValidationErrors | null => {
	if (control && control.value && !control.value.replace(/\s/g, '').length) {
		return {cannotContainSpace: true};
	}

	return null;
};
